export enum AppCostSource {
	Records = 1,
	Plans = 2,
	RecordsAndPlans = 3,
}

export enum BiomassLevel {
	Low = 1,
	Average = 2,
	High = 3,
}

export enum BiomassUnit {
	NDVI = 1,
	LAI = 2,
	YaraBiomassIndex = 3,
	CHI = 4,
	EVI = 5,
}

export enum BusinessId {
	Hutchinsons = 1,
	Farmacy = 2,
	CropWise = 3,
	Agrivice = 4,
	Vassgro = 5,
	GardinerICM = 6,
	CobbAgri = 1000,
	Wynnstay = 1001,
	OwenFarmServices = 1002,
	BoolCropSpecialists = 1003,
}

export enum CropCategory {
	Cereal = 1,
	Mixed = 2,
	Root = 3,
	FieldVeg = 4,
	Fruit = 5,
	Forage = 6,
	CoverCrop = 7,
	Other = 8,
	Salad = 9,
	Grass = 10,
	Herbs = 11,
	Ornamentals = 12,
	Forestry = 13,
	Amenity = 14,
}

export enum CropDisease {
	Mildew = 1,
	YellowRust = 2,
	BrownRust = 3,
	Septoria = 4,
	Eyespot = 5,
	Rhynchosporium = 6,
	NetBlotch = 7,
}

export enum CropId {
	Uncropped = 0,
	WinterWheat = 1,
	SpringWheat = 2,
	WinterBarley = 4,
	SpringBarley = 5,
	WinterOilseedRape = 6,
	SpringOilseedRape = 7,
	WinterOats = 8,
	SpringOats = 9,
	WinterTriticale = 10,
	SpringRye = 11,
	Potatoes = 13,
	SugarBeet = 18,
	Carrots = 20,
	Strawberries = 24,
	Raspberries = 25,
	Apples = 26,
	Pears = 27,
	Blackcurrants = 28,
	Parsnips = 47,
	CoverCrop = 50,
	Fallow = 51,
	Other = 52,
	GrassMargin = 53,
	Grass = 54,
	CatchCrop = 56,
	FodderBeet = 59,
	Cherries = 60,
	Hops = 61,
	ForageTriticale = 63,
	ForageMaize = 65,
	Maize = 161,
	GameCover = 67,
	Plums = 71,
	Redcurrants = 72,
	Blackberries = 73,
	Phacelia = 83,
	OilseedRaddish = 84,
	Apricots = 90,
	EFA = 91,
	OutdoorPigs = 92,
	OutdoorPoultry = 93,
	WinterRye = 96,
	Woodland = 112,
	NonFarmedArea = 113,
	SfiCropAction = 354,
}

export enum CropMaltingOption {
	Brewing = 1,
	Distilling = 2,
}

export enum CropProtectionStatus {
	Outdoor = 1,
	PermanentProtection = 2,
	TemporaryProtection = 3,
}

export enum CropPurpose {
	Feed = 1,
	Malting = 2,
	Milling = 3,
	Dessert = 4,
	Culinary = 5,
	Cider = 6,
	Forage = 7,
	Grain = 14,
	Maincrop = 15,
	FirstEarly = 16,
	SecondEarly = 17,
	Seed = 18,
	Winter = 19,
	Summer = 20,
	Wine = 21,
	Table = 22,
	Dry = 23,
	Fresh = 24,
}

export enum CropResidue {
	Incorporated = 1,
	Baled = 3,
}

export enum CropStyleFillPattern {
	None = 0,
	Vertical = 1,
	Horizontal = 2,
	LeftDiagonal = 3,
	RightDiagonal = 4,
}

export enum DiseaseSensitivity {
	Low = 1,
	Medium = 2,
	High = 3,
	VeryHigh = 4,
}

export enum DistanceUnit {
	Metre = 1,
	Foot = 2,
}

export enum ExternalAppId {
	OmniaConnect = 1,
	Dropbox = 100,
	iSoyl = 101,
	JohnDeere = 200,
	Claas = 210,
	FieldView = 220,
	Glgm = 301,
}

export enum ExternalAppStatus {
	Ok = 0,
	InvalidConnection = 1,
	InvalidOrganisation = 2,
}

export enum FertiliserAppUnit {
	Kg = 1,
	T = 2,
	L = 3,
	M3 = 4,
}

export enum FertiliserLiquidUnit {
	WeightForVolume = 1,
	WeightForWeight = 2,
}

export enum FieldAreaType {
	WholeArea = 1,
	WorkingArea = 2,
	BoundaryArea = 3,
}

export enum FieldDrainage {
	LandDrains = 1,
	MoleDrained = 2,
	NoDrainage = 3,
}

export enum GenericPlanUnitId {
	kg_ha = 1,
	t_ha = 2,
	l_ha = 3,
	m3_ha = 4,
	seeds_m2 = 5,
	seeds_ha = 6,
}

export enum GrassCuts {
	One = 1,
	Two = 2,
	Three = 3,
	More = 999,
}

export enum GrassManagement {
	Cut = 1,
	CutGrazed = 2,
	IntensiveGrazing = 3,
	ExtensiveGrazing = 4,
	NaturalSemiNatural = 5,
	Dehydrated = 6,
	DehydratedIrrigation = 7,
	Seed = 8,
	HerbalLey = 9,
	SilageAndGrazingTwoMoreCuts = 100,
	SilageAndGrazingOneCut = 101,
	GrazingLowClover = 102,
	HayAndGrazing = 103,
	GrassHighClover = 104,
}

export enum GrassManagementEngland {
	Cut = 1,
	CutGrazed = 2,
	IntensiveGrazing = 3,
	ExtensiveGrazing = 4,
	NaturalSemiNatural = 5,
	Dehydrated = 6,
	DehydratedIrrigation = 7,
	Seed = 8,
	HerbalLey = 9,
}

export enum GrassManagementScotland {
	SilageAndGrazingTwoMoreCuts = 100,
	SilageAndGrazingOneCut = 101,
	GrazingLowClover = 102,
	HayAndGrazing = 103,
	GrassHighClover = 104,
}

export enum GrassNCropGroup {
	G201 = 201,
	G300 = 300,
	G301 = 301,
	G302 = 302,
	G401 = 401,
	G402 = 402,
	G403 = 403,
	G501 = 501,
	G502 = 502,
	G503 = 503,
	G601 = 601,
	G602 = 602,
}

export enum GrassSiteClass {
	C1 = 1,
	C2 = 2,
	C3 = 3,
	C4 = 4,
	C5 = 5,
}

export enum GridSampleAnalysisType {
	SoilAnalysis = 1,
	PCN = 2,
}

export enum GrowingSeasonLength {
	L60 = 1,
	L60_90 = 2,
	L60_90_ware = 5,
	L60_90_seed = 6,
	L90_120 = 3,
	L120 = 4,
}

export enum HeadlandIncreaseUnit {
	Pct = 1,
	SeedsM2 = 2,
	KgHa = 3,
}

export enum HoldingNotificationId {
	Field_Boundary_Overlaps = 1000,
	Cropping_Dates_StartBeforeEnd = 2000,
	Cropping_Dates_WrongYear = 2001,
	Cropping_Area_LargerThanField_1 = 2002,
	Cropping_Area_LargerThanField_2 = 2003,
	Cropping_Boundary_Overlaps = 2004,
	Cropping_Boundary_OutsideFieldBoundary = 2005,
	Cropping_History_PrevNotSet = 2006,
}

export enum ImportHistoryProvider {
	Gatekeeper = 1,
	Muddyboots = 2,
	Omnia = 3,
	AgLeader = 4,
	CaseNewHolland = 5,
	CLAAS = 6,
	FarmWorks = 7,
	JohnDeere = 8,
	IsoXml = 9,
	GenericCsv = 10,
	GenericShp = 11,
	PlantVision = 12,
	Yara = 13,
	PrecisionDecision = 14,
	Lancrop = 15,
	NRM = 16,
	RAA = 17,
	RootPlanner = 18,
	RDS = 19,
	KML = 20,
	Soyl = 21,
	TerraMap = 22,
	RPA = 23,
	SSM = 24,
	ClimateFieldView = 25,
	Rhiza = 26,
	FarmTRX = 27,
	ScotGov = 28,
}

export enum ImportHistoryType {
	Layers = 1,
	Boundaries = 2,
	GridSamples = 3,
	SoilAnalysis = 4,
	Holding = 5,
	Balance = 6,
}

export enum LayerStorageMode {
	GenericTable = 0,
	CustomTable = 1,
}

export enum LayerTypeGroupId {
	SoilPhysical = 1,
	SoilAnalysis = 2,
	Yield = 3,
	ApplicationPlans = 4,
	Biomass = 5,
	TerraMap = 6,
	WeedPestPressure = 7,
	Other = 999,
}

export enum LayerTypeId {
	SoilType = 1,
	SubsoilType = 2,
	SoilAnalysis = 3,
	EcScan = 4,
	PcnAnalysis = 5,
	P2O5 = 10,
	K2O = 11,
	MgO = 12,
	pH = 13,
	Sand = 14,
	Silt = 15,
	Clay = 16,
	OrganicMatter = 17,
	CEC = 18,
	Calcium = 19,
	Sodium = 20,
	Manganese = 21,
	Molybdenum = 22,
	Boron = 23,
	Copper = 24,
	Iron = 25,
	Zinc = 26,
	Sulphur = 27,
	PAWI = 28,
	Elevation = 29,
	KMgRatio = 30,
	OrganicCarbonPct = 31,
	OrganicCarbonTHa = 32,
	ActiveCarbonPct = 33,
	ActiveCarbonTHa = 34,
	CarbonActivePct = 35,
	SiltClay = 36,
	SOCClay = 37,
	TotalCa = 38,
	TotalMgO = 39,
	TotalK2O = 40,
	TotalNa = 41,
	TotalSO3 = 42,
	TotalP2O5 = 43,
	AvailableCa = 44,
	AvailableMgO = 45,
	AvailableK2O = 46,
	AvailableNa = 47,
	AvailableSO3 = 48,
	AvailableP2O5 = 49,
	BufferpH = 50,
	TotalCaMgRatio = 51,
	BulkDensity = 52,
	Yield = 100,
	YieldFieldPerformance = 101,
	YieldTrend = 102,
	YieldAverage = 103,
	SeedRate = 200,
	SlugPressure = 201,
	WeedPressure = 202,
	SeedbedCondition = 203,
	EstablishmentPct = 204,
	Biomass = 300,
	NutrientRequirements = 400,
	NutrientApplications = 500,
	Drawing = 600,
	Picture = 601,
	GenericPlan = 700,
	PrescriptionPlan = 710,
}

export enum LayerTypeSubgroupId {
	TerraMapStandard = 6001,
	TerraMapSoil = 6002,
	TerraMapAdditional = 6003,
	TerraMapTotal = 6004,
	TerraMapAvailable = 6005,
	TerraMapOther = 6999,
}

export enum LayerValueType {
	Discrete = 1,
	Numeric = 2,
}

export enum LayerZoneTypeId {
	Field = 1,
	Text = 2,
}

export enum LimingFactor {
	Arable = 1,
	Grassland = 2,
}

export enum ManureAppMethod {
	SurfaceApplied = 1,
	Incorporated24H = 2,
	Incorporated6H = 3,
	BandSpread = 4,
	ShallowInjected = 5,
	DeepInjected = 6,
}

export enum ManureUnit {
	T = 2,
	M3 = 4,
}

export enum MapGeometryType {
	Point = 1,
	Linestring = 2,
	Polygon = 3,
	Grid = 4,
}

export enum MapImportFileFormat {
	CSV = 1,
	SHP = 2,
	KML = 3,
}

export enum MapImportKnownFileType {
	Generic_CSV = 1,
	Generic_SHP = 2,
	Generic_KML = 3,
	Omnia_PCN_ShpCsv = 50,
	Rhiza_Boundaries = 60,
	Rhiza_SoilTexture = 61,
	Rhiza_SoilAnallysis = 62,
	Rhiza_EcScan = 63,
	PlantVision_NDVI = 100,
	PrecisionDecisions_EcScan = 200,
	Yara_NSensor = 300,
	FarmWorks_Yield = 400,
	AgLeader_SMS_Yield = 401,
	JohnDeere_Yield = 402,
	FarmTRX_Yield = 403,
	Gatekeeper_Yield = 500,
	Claas_Yield_AFT = 600,
	Claas_Boundaries_API = 601,
	IsoXml_Boundaries = 700,
	IsoXml_Yield = 701,
	CaseNewHolland_Boundaries = 800,
	CaseNewHolland_Yield = 801,
	RDS_Yield = 900,
	Soyl_Boundaries = 1000,
	Soyl_SoilSamples = 1001,
	RPA_Boundaries = 1100,
	ScotGov_Boundaries = 1101,
	RPA_Hedges = 1102,
	Climate_FieldView_Boundaries = 1200,
	Omnia_Yield = 1300,
	TerraMap_SoilOptix = 2000,
	TerraMap_SoilOptix_Api_V3 = 2001,
	SpaceSense_Api = 3000,
}

export enum MapImportTaskType {
	Layers = 1,
	Boundaries = 2,
}

export enum MapRegularShapeType {
	Circle = 1,
	Rectangle = 2,
	Square = 3,
}

export enum MapScope {
	Field = 1,
	Cropping = 2,
	Holding = 3,
}

export enum NitrogenAnalysisType {
	NMIN = 1,
	SMN = 2,
	FarmAssessment = 3,
}

export enum NitrogenSnsMethod {
	FarmAssessment = 1,
	NMIN = 2,
	SMN = 3,
}

export enum NLeafAnalysis {
	TooLow = 1,
	Low = 2,
	Satisfactory = 3,
	High = 4,
	TooHigh = 5,
}

export enum NMaxGroupId {
	WinterWheat = 1,
	SpringWheat = 2,
	WinterBarley = 3,
	SpringBarley = 4,
	WinterOilseedRape = 5,
	SugarBeet = 6,
	Potatoes = 7,
	ForageMaize = 8,
	FieldBeans = 9,
	Peas = 10,
	Grass = 11,
	HortGroup1 = 12,
	HortGroup2 = 13,
	HortGroup3 = 14,
}

export enum NtrReqConfigMode {
	WholeField = 1,
	Precision = 2,
	SoilAnalysis = 3,
}

export enum NutrientGroup {
	NS = 3,
	PK = 28,
	Lime = 32,
	AllNutrients = 63,
}

export enum NutrientType {
	N = 1,
	SO3 = 2,
	P2O5 = 3,
	K2O = 4,
	MgO = 5,
	Lime = 6,
}

export enum OmniaModuleId {
	Fields = 1,
	Layers = 2,
	Soil = 3,
	Stocks = 4,
	Seeds = 5,
	Nutrition = 6,
	Manure = 7,
	FieldPerformance = 8,
	Reports = 9,
	CostOfProduction = 10,
	Imports = 11,
	Exports = 12,
	Climate = 13,
	AppConnections = 14,
	Holding = 15,
	UserAccount = 16,
	FieldDiary = 17,
	Dashboard = 18,
	Satellite = 19,
	Shed = 20,
	Planning = 21,
	AsApplied = 22,
	Prescriptions = 23,
	CropProtection = 24,
	Reports2 = 25
}

export enum OmniaObjectType {
	Holding = 1,
	Field = 2,
	Cropping = 3,
	CroppingYear = 4,
	CustomProduct = 5,
	Layer = 101,
	YieldMapScale = 102,
	GenericPlan = 103,
	SoilAnalysis = 201,
	NitrogenAnalysis = 202,
	PcnAnalysis = 203,
	HsAnlaysis = 204,
	SeedStock = 301,
	FertiliserStock = 302,
	ManureStock = 303,
	Stock = 304,
	StockTransaction = 305,
	StockLocation = 306,
	StockSupplier = 307,
	SeedPlan = 401,
	SeedPlanMap = 402,
	NutritionRequirement = 501,
	NutritionPlan = 502,
	NutritionAppZone = 503,
	NutritionNMax = 504,
	NutritionBalance = 505,
	NutritionPlanTemplate = 506,
	ManurePlan = 601,
	ManureRiskMap = 602,
	ManureLivestock = 603,
	ManureStorage = 604,
	ManureExports = 605,
	FieldPerformance = 701,
	Report = 801,
	ReportingTask = 802,
	ReportMapRegion = 803,
	ProductionCost = 901,
	ProductionCroppingConfig = 902,
	Silo = 903,
	PowerUnit = 904,
	Implement = 905,
	Operation = 906,
	OperationGroup = 907,
	HarvestedAmount = 908,
	BoundaryImportTask = 1101,
	LayerImportTask = 1102,
	AnalysisImportTask = 1103,
	HoldingImportTask = 1104,
	ImportFieldBoundaries = 1105,
	ImportCroppingBoundaries = 1106,
	ImportLayers = 1107,
	ImportDocuments = 1108,
	FieldDiaryEntry = 1201,
	ExportPlans = 1301,
	ExportNutitionPlans = 1302,
	ExportSeedPlans = 1303,
	ExportBoundaries = 1304,
	ExportLayers = 1305,
	ClimateStation = 1401,
	ClimateGrowthStage = 1402,
	ClimateRisk = 1403,
	SatelliteLayerTask = 1501,
	PrescriptionPlan = 1601,
	PrescriptionTemplate = 1602,
	SprayPlan = 1701,
	SprayPlanIfsOrder = 1702,
}

export enum OrderInvoice {
	Grower = 1,
	Hutchinson = 2,
	Farmacy = 3,
}

export enum PlanType {
	SeedPlan = 1,
	NutritionPlan = 2,
	GenericProductPlan = 3,
	PrescriptionPlan = 4,
	SprayPlan = 5,
	Other = 6,
	NutritionPlan2024 = 7,
}

export enum ProductAppInput {
	NutrientPct = 1,
	NutrientRate = 2,
	ProductRate = 3,
}

export enum Provider {
	Gatekeeper = 1,
	Muddyboots = 2,
	Omnia = 3,
}

export enum RegionId {
	England = 1,
	Scotland = 2,
	Wales = 3,
	Poland = 4,
	Hungary = 5,
	France = 6,
	Belgium = 7,
	Netherlands = 8,
	Germany = 9,
	Romania = 10,
	Bulgaria = 11,
	Spain = 12,
	Czechia = 13,
	Slovakia = 14,
	Italy = 15,
	Turkey = 16,
	Greece = 17,
	Albania = 18,
	Andorra = 19,
	Armenia = 20,
	Austria = 21,
	Azerbaijan = 22,
	Belarus = 23,
	BosniaHerzegovina = 24,
	Croatia = 25,
	Cyprus = 26,
	Denmark = 27,
	Estonia = 28,
	Finland = 29,
	Georgia = 30,
	Iceland = 31,
	Ireland = 32,
	Kazakhstan = 33,
	Kosovo = 34,
	Latvia = 35,
	Liechtenstein = 36,
	Lithuania = 37,
	Luxembourg = 38,
	Malta = 39,
	Moldova = 40,
	Monaco = 41,
	Montenegro = 42,
	NorthMacedonia = 43,
	Norway = 44,
	Portugal = 45,
	Russia = 46,
	SanMarino = 47,
	Serbia = 48,
	Sweden = 49,
	Switzerland = 50,
	Ukraine = 51,
}

export enum RiskRegionId {
	East = 1,
	Midlands = 2,
	North = 3,
	NorthEast = 4,
	NorthWest = 5,
	South = 6,
	SouthEast = 7,
	SouthWest = 8,
	West = 9,
	Wales = 40,
	ScotlandEast = 50,
	ScotlandNorth = 51,
	ScotlandWest = 52,
}

export enum SatImageType {
	NDVI = 1,
	RGB = 2,
	CHI = 3,
	EVI = 4,
	PlanetNDVI = 101,
	PlanetRGB = 102,
	PlanetCHI = 103,
}

export enum SoilAnalysisImportStep {
	Mapping = 1,
	Layers = 2,
	Completed = 3,
}

export enum SoilAnalysisLayerSubtype {
	SoilAnalysis = 1,
	GridSamples = 2,
}

export enum SoilAnalysisProvider {
	Lancrop = 1,
	NRM = 2,
	RAA = 3,
	SSM = 4,
}

export enum SoilAnalysisType {
	Standard = 0,
	SSM = 1,
}

export enum SoilCategory {
	Light = 1,
	Medium = 2,
	Heavy = 3,
	Silt = 4,
	Organic = 5,
	Peat = 6,
}

export enum SoilErosionRisk {
	Low = 1,
	LowModerate = 2,
	Moderate = 3,
	High = 4,
	VeryHigh = 5,
}

export enum SoilP2O5Method {
	Olsen = 1,
	Morgan = 2,
}

export enum SoilTypeId {
	Clay = 1,
	SiltyClay = 2,
	SiltyClayLoam = 3,
	SiltyLoam = 4,
	SandySiltLoam = 5,
	ClayLoam = 6,
	SandyClay = 7,
	SandyClayLoam = 8,
	SandyLoam = 9,
	LoamySand = 10,
	Sand = 11,
	Organic = 12,
	Peat = 13,
}

export enum SprayQuality {
	Coarse = 1,
	MediumCoarse = 2,
	Medium = 3,
	MediumFine = 4,
	Fine = 5,
	NotApplicable = 6,
}

export enum SsmClassId {
	VeryLow = 1,
	Low = 2,
	Optimum = 3,
	High = 4,
	VeryHigh = 5,
}

export enum StockType {
	Seed = 1,
	Fertiliser = 2,
	Manure = 3,
	CropProtection = 4,
}

export enum SubsoilTypeId {
	Shallow = 1,
	ShallowOverSandstone = 2,
	Chalk = 3,
	Limestone = 4,
	SandstoneStand = 5,
	Shale = 6,
	Silt = 7,
	Clay = 8,
}

export enum SyncEventStatus {
	Ok = 0,
	Error = 1,
	VersionConflict = 2,
	NotSupported = 3,
}

export enum TaskStatus {
	NotSet = 0,
	Pending = 1,
	Running = 2,
	Done = 3,
	Error = 4,
	WaitingUserInput = 5,
}

export enum TerraMapLayerType {
	Raw = 1,
	External = 2,
	RawDynamicScale = 3,
}

export enum TradingContractType {
	Spot = 1,
	Forward = 2,
}

export enum WindErosionRisk {
	NotProne = 1,
	MayBeProne = 2,
	Prone = 3,
	VeryProne = 4,
}

export enum YieldLayerSubtype {
	TargetYield = 1,
	ActualYield = 2,
}

export enum YieldPotentialCategory {
	Inconsistent = 1,
	ConsistentlyGood = 2,
	InconsistentlyGood = 3,
	ConsistentlyAcceptable = 4,
	InconsistentlyPoor = 5,
	ConsistentlyPoor = 6,
}

